import withProps from "recompose/withProps";
import uuid from "@gqlapp/base/utils/uuid";
import isEmpty from "@gqlapp/base/utils/isEmpty";
import isArray from "@gqlapp/base/utils/isArray";
import RenderField from "@xem/look/Renders/Field";


export const withClick = withProps(({ blockProps, onClick, values })=>{
	if(onClick){
		blockProps = Object.assign({}, blockProps, { onClick: onClick({ data: values }) })
	}
	return { blockProps }
});


export function fieldConfig ({ setFieldValue, tabIndex, name, value, inputProps, ...props }: any) {
	tabIndex = tabIndex || 1;
	return {
		...{ onRemove: setFieldValue },
		...{ component: RenderField},
		...{ inputProps: { ...inputProps, tabIndex: tabIndex++ } },
		...{ name, value }, ...props
	}
}

/**
 * background Color
 * @param _ITEM
 * @param value
 */
export function bgStyle(_ITEM: any, value: any) {
	if (value && value?.toLowerCase().includes('gradient')) {
		Object.assign(_ITEM, { backgroundImage: value });
	} else {
		Object.assign(_ITEM, {
			backgroundColor: `${value}`
		})
	}
}

/**
 * Border Style
 * @param __ITEM
 * @param border
 */
export function borderStyle(__ITEM: any, border: any) {
	if(border && border.value){
		let { color, value } = border || {}
		value 		&& Object.assign(__ITEM,{ 'borderWidth': `${value}px` });

		if(color && color?.toLowerCase().includes('gradient')){
			Object.assign(__ITEM,{ 'borderImageSource': `${color}` });
			Object.assign(__ITEM,{ 'borderImageSlice': `1` });
			Object.assign(__ITEM,{ 'borderColor': `transparent` });
			Object.assign(__ITEM,{ 'borderStyle': `solid` });
		}else if(color){
			Object.assign(__ITEM,{ 'borderColor': `${color}` });
			Object.assign(__ITEM,{ 'borderStyle': `solid` });
		}
	}
}


/**
 * Shadow Style
 * @param __ITEM
 * @param shadow
 */
export function shadowStyle(__ITEM: any, shadow: any) {
	let { color, x_offset_left, y_offset_left, blur, spread } = shadow || {}

	if(x_offset_left || y_offset_left || blur || spread ){
		x_offset_left = x_offset_left || 0
		y_offset_left = y_offset_left || 0
		blur = blur || 0
		spread = spread || 0
		color = color || '#000000';

		if(color && (x_offset_left || y_offset_left || blur || spread)){
			Object.assign(__ITEM,{
				boxShadow: `${x_offset_left}px ${y_offset_left}px ${blur}px ${spread}px ${color}`
			});
		}
	}
}


/**
 *
 * @param _ITEM_TEXT
 * @param titleStyle
 */
function textfieldStyle(_ITEM_TEXT: any, titleStyle: any) {
	let weight: string, transform: string, family: string, color: string, fontSize: string;

	if((color = titleStyle?.color)) {
		Object.assign(_ITEM_TEXT, { color });
	}

	if((transform = titleStyle?.transform) && (transform).toLowerCase() === 'uppercase'){
		Object.assign(_ITEM_TEXT, { textTransform:  `uppercase` })
	}

	if((family = titleStyle?.family)) {
		Object.assign(_ITEM_TEXT, { fontFamily: family });
	}

	if((weight = titleStyle?.weight)) {
		Object.assign(_ITEM_TEXT, { fontWeight: weight});
	}

	if((fontSize = titleStyle?.fontSize)) {
		Object.assign(_ITEM_TEXT, { fontSize });
	}
}


/**
 * getSpace
 * @param values
 */
function getSpace(values: any){
	let { value, top, left, right, bottom } = values || {}

	if(!!value){
		top = left = right = bottom = value;
	}

	top = top || 0;
	bottom = bottom || 0;
	left = left || 0;
	right = right || 0;
	return { top, bottom, left, right }
}

/**
 *
 * @param ITEM
 * @param space
 */
export function spaceToStyle(ITEM: any, space: any) {
	let { value, top, left, right, bottom } = space || {}

	if(!!(value)){
		top = left = right = bottom = value;
	}

	top = top || 0;
	bottom = bottom || 0;
	left = left || 0;
	right = right || 0;

	top 		&& Object.assign(ITEM,{ paddingTop: `${top}px`});
	bottom 		&& Object.assign(ITEM,{ paddingBottom: `${bottom}px`});
	left 		&& Object.assign(ITEM,{ paddingLeft: `${left}px`});
	right 		&& Object.assign(ITEM,{ paddingRight: `${right}px`});
}


/**
 * getRadius
 * @param values
 */
export function getRadius(values: any){
	let { value, top_left, top_right, bottom_left, bottom_right } = values || {}

	if(!!value){
		top_left = top_right = bottom_left = bottom_right = value;
	}

	top_left = top_left || 0
	top_right = top_right || 0
	bottom_left = bottom_left || 0
	bottom_right = bottom_right || 0

	let __BTN = {}

	Object.assign(__BTN,{ borderRadius: `${top_left}px ${top_right}px ${bottom_right}px ${bottom_left}px`})

	return __BTN
}

/**
 * styleMap
 * @param data
 */
export function styleMap(data: any){

	let __STYLE: any = {}, __ITEM: any = {}, blockProps: any = {}

	let { backgroundColor, border, shadow, padding, radius, margin, settings } = data || {}

	bgStyle(__ITEM, backgroundColor);
	borderStyle(__ITEM, border);
	shadowStyle(__ITEM, shadow);

	let __THEME = {}
	spaceToStyle(__ITEM, padding);
	spaceToStyle(__THEME, margin);

	if(typeof radius?.value === 'number'){
		Object.assign(__ITEM, getRadius(radius || {}));
	}

	if(settings){
		let { on, backgroundColor } = settings || {}

		bgStyle(__THEME, backgroundColor);

		if(!!on){
			Object.assign(blockProps, { name: settings?.name ?? null })
		}
	}

	Object.assign(__THEME, {
		'&.pointer': {
			minHeight: '10px',
			position: 'relative',
			'&:before':{
				zIndex: 1000,
				position: 'absolute',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				content: '" "',
				display: 'block',
				width: 'calc(100%)',
				height: 'calc(100%)'
			}
		}
	});

	if(Object.keys(__ITEM).length){
		Object.assign(__THEME, {
			'& .block-item': __ITEM
		})
	}

	Object.assign(__STYLE, {
		'& .block-theme': __THEME
	});

	return { sx: __STYLE, blockProps };
}

/**
 * styleText
 * @param sx
 * @param name
 * @param settings
 * @param isBackground
 */
export function styleText(sx: any, name: string, settings: any, isBackground: boolean = false){
	let { color, family, transform, weight} = settings || {}

	let __SX = {};

	__SX[name] = __SX[name] || {}

	if(weight === 'bold'){
		Object.assign(__SX[name], { fontWeight:  `600` })
	}

	else if(weight === 'light'){
		Object.assign(__SX[name], { fontWeight:  `400` })
	}

	if(`${transform}`.toLowerCase() === 'uppercase'){
		Object.assign(__SX[name], { textTransform:  `uppercase` })
	}

	family 		&& Object.assign(__SX[name], { fontFamily:  `${family}` })

	if(color && color?.toLowerCase().includes('gradient')){
		Object.assign(__SX[name], {
			backgroundImage: color,
			WebkitBackgroundClip: 'text',
			WebkitTextFillColor: 'transparent'
		})
	}else if(isBackground && color){
		Object.assign(__SX[name], { backgroundColor: color });
	}else if(color){
		Object.assign(__SX[name], { color: color });
	}

	Object.assign(sx, __SX)
}

/**
 * styleAdd
 * @param sx
 * @param name
 * @param styles
 */
export function styleAdd(sx: any, name: string, styles: any){
	if(Object.keys(styles).length){
		let __SX = {};
		__SX[name] = styles;
		Object.assign(sx, __SX)
	}
}
/**
 * fieldMap
 * @param value
 */
export function fieldMap(value: any){
	delete value.form_id;
	return value;
}

/**
 *
 * @param id
 * @param weight
 * @param button
 * @param input
 * @param values
 * @param data
 */
export function dataMap({ id, weight, button, input,...values }: any & { id: string }, data: any[]){

	let dataValues: Map<string, any> = new Map();
	id  = id || uuid();
	data = data || [];

	(data || []).map(({ key, value }: any)=>{
		if(value.blockType === 'form'){
			value.fields = (value.fields || []).map(fieldMap)
		}
		dataValues.set(key, value)
	});

	if(weight === -1 || typeof weight === 'undefined'){
		weight = data.length
	}

	Object.assign(values, { weight })

	if((typeof input !=='undefined') && !isArray(input) && !isEmpty(input)){
		Object.assign(values, { input })
	}

	if((typeof button !=='undefined') && !isArray(button) && !isEmpty(button)){
		Object.assign(values, { button })
	}

	dataValues && dataValues.set(id, values);

	let _DATA = [];
	try{
	// @ts-ignore
		[...dataValues.entries()].map(([key, value])=>_DATA.push({ key, value }));
	}catch (e) {}

	return _DATA;
}

/**
 * btnStyle
 * @param sx
 * @param name
 * @param settings
 */
export function btnStyle(sx: any, name: string, settings: any){
	let _ITEM = {}

	bgStyle(_ITEM, settings?.backgroundColor);
	borderStyle(_ITEM, settings?.border);
	shadowStyle(_ITEM, settings?.shadow);

	{
		if(typeof settings?.radius?.value === 'number'){
			Object.assign(_ITEM, getRadius(settings?.radius || {}));
		}

		let padding: any;
		if((padding = settings?.padding)){
			let { top, left, right, bottom} = getSpace(padding);
			Object.assign(_ITEM, { padding: `${top}px ${right}px ${bottom}px ${left}px`});
		}
	}

	{
		let weight: string, transform: string, family: string, color: string, fontSize: string;

		Object.assign(_ITEM, { fontSize: '18px'});

		if((color = settings?.titleStyle?.color)) {
			Object.assign(_ITEM, { color });
		}

		if((transform = settings?.titleStyle?.transform) && (transform).toLowerCase() === 'uppercase'){
			Object.assign(_ITEM, { textTransform:  `uppercase` })
		}

		if((family = settings?.titleStyle?.family)) {
			Object.assign(_ITEM, { fontFamily: family });
		}

		if((weight = settings?.titleStyle?.weight)) {
			Object.assign(_ITEM, { fontWeight: weight});
		}

		if((fontSize = settings?.titleStyle?.fontSize)) {
			Object.assign(_ITEM, { fontSize });
		}
	}


	styleAdd(sx, `${name}`, _ITEM);
}

/**
 * textStyle
 * @param sx
 * @param name
 * @param settings
 */
export function textStyle(sx: any, name: string, settings: any){
	let _ITEM = {};

	let radius = getRadius(settings?.radius || {})
	Object.assign(_ITEM, radius);

	let value:string;

	Object.assign(_ITEM, { '& .MuiInputBase-multiline:not(.Mui-error)':{ marginBottom: '16px' } });

	if((value = settings?.backgroundColor)){
		Object.assign(_ITEM, { '& .MuiInputBase-root':{ backgroundColor: value }});
	}


	if((value = settings?.label)){
		Object.assign(_ITEM, { '& .MuiFormLabel-root':{ color: value }});
	}


	if((value = settings?.outline)){
		Object.assign(_ITEM, {
			// '& .MuiFormLabel-root':{ color: value },
			'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':{ borderColor: value },
			'& .MuiSvgIcon-root':{ fill: value }
		});
	}

	if((value = settings?.focus)){
		Object.assign(_ITEM, {
			'& .MuiFormLabel-root.Mui-focused':{ color: value },
			'& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline':{ borderColor: value },
			'& .MuiSvgIcon-root':{ fill: value }
		});
	}



	if((value = settings?.error)){
		Object.assign(_ITEM, {
			'& .Mui-error':{
				'&>.MuiFormHelperText-root, & label.MuiFormLabel-root, &.MuiFormLabel-root, &.MuiFormHelperText-root':{ color: value },
				'&, &.Mui-focused, & .Mui-focused':{ '& .MuiOutlinedInput-notchedOutline':{ borderColor: value } },
			}
		});
	}

	{
		let _ITEM_TEXT= {};
		textfieldStyle(_ITEM_TEXT, settings?.titleStyle)

		if((value = settings?.placeholder)){
			Object.assign(_ITEM_TEXT, { '&':{'&::placeholder':{ color: value }}});
		}


		if(Object.keys(_ITEM_TEXT).length){
			Object.assign(_ITEM,{ '& .MuiInputBase-input':_ITEM_TEXT })
		}
	}

	styleAdd(sx, `${name}`, _ITEM);
}
/**
 *
 */
export default withProps(()=>{});